import React from 'react'
import './Presbyter.css'

const Presbyter = () => {
  return (
    <div className='presbyter'>
        <div className="container pt-5">
            <div className="row">
                <div className="col-md-6">
                    <img src="roland.jpeg" alt="pastor" className='pastor'/>
                </div>
                <div className="col-md-6 presbyter-right">
                    <span className="incharge">
                        Presbyter-in-Charge
                    </span>
                    <p className='rev'>
                        Rev. G. John Roland
                    </p>
                    <p className='pt-4 pb-3'>
                        <a href="mailto:rolandgfabs@yahoo.com" className='email text-decoration-none text-dark mb-3'>
                        rolandgfabs@yahoo.com
                        </a>
                    </p>
                    <b>
                    +91-9324163207 <br/>
                    +91-9566254298 (WhatsApp)
                    </b>
                </div>
            </div>
        </div>
    </div>
  )
}

export default Presbyter